<template>
  <ul class="barchart-wrapper">
    <li class="border-item" v-for="person in lista_encuestas.slice(0,5)" :key="person.id">      
      <div>
        <h3 class="respuesta-name">{{ person.options }}</h3>
        <div class="partido">{{ person.partido }}</div>
        <div class="barra-wrapper mt-2 mb-2">
          <div :style="`background-color: ${person.color}; width:${CalcularBarra(person.date_one)}%`" class="barra">
            <div :style="`color: ${person.color}`" class="porcentaje">{{ person.date_one }}<span class="symbol">%</span></div>
          </div>
        </div>
      </div>      
    </li>    
    <b-collapse :id="kebabCase(pregunta_id)">
      <li class="border-item" v-for="person in lista_encuestas.slice(5, lista_encuestas.length)" :key="person.id">      
        <div>
          <h3 class="respuesta-name">{{ person.options }}</h3>
          <div class="partido">{{ person.partido }}</div>
          <div class="barra-wrapper mt-2 mb-2">
            <div :style="`background-color: ${person.color}; width:${CalcularBarra(person.date_one)}%`" class="barra">
              <div :style="`color: ${person.color}`" class="porcentaje">{{ person.date_one }}<span class="symbol">%</span></div>
            </div>
          </div>
        </div>      
      </li>
    </b-collapse>
    <b-button class="btn-read-more" v-if="lista_encuestas.length > 5" @click="openAll(kebabCase(pregunta_id))">{{ read_more }} <iconPlus v-if="!open" /><iconMinus v-if="open" /></b-button>
    <customNote :pregunta-parent="preguntaParent" />    
  </ul>
</template>

<script>

import customNote from '@/components/customNote.vue'
import iconPlus from '@/components/iconPlus.vue'
import iconMinus from '@/components/iconMinus.vue'
import { kebabCase, maxBy, map, uniq } from 'lodash'
import * as d3 from 'd3'

export default {
  name: 'BarChart',
  components: {
    customNote,
    iconPlus,
    iconMinus
  },
  props: {
    lista_encuestas: Array,
    preguntaParent: Object
  },
  data() {
    return {
      read_more: `Leer todas las respuestas`,
      open: false
    }
  },
  computed: {
    pregunta_id() {
      return `pregunta-container-${uniq(map(this.    lista_encuestas, 'question_id'))}`
    }
  },
  methods: {
    kebabCase,
    openAll(id) {
      this.$root.$emit('bv::toggle::collapse', id)
      this.open = !this.open
      this.read_more = !this.open ? `Leer todas las respuestas` : `Mostrar menos respuestas`
    },
    CalcularBarra(porcentaje) {
      let max = maxBy(this.lista_encuestas, "date_one")
      let scale = d3.scaleLinear().domain([0, max.date_one]).range([0, 100])
      return scale(parseInt(porcentaje))
    }
  }
}
</script>
